import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/lib/auth";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import ClientProfile from "@/pages/ClientProfile";
import NewAnalysis from "@/pages/NewAnalysis";
import AnalysisDetail from "@/pages/AnalysisDetail";
import Plans from "@/pages/Plans";
import Admin from "@/pages/Admin";
import Help from "@/pages/Help";
import Academy from "@/pages/Academy";
import Updates from "@/pages/Updates";
import Profile from "@/pages/Profile";
import BetaColor from "@/pages/BetaColor";
import PortalCliente from "@/pages/PortalCliente";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FAFAFA]">
        <div className="w-10 h-10 rounded-full border-2 border-[#E5E5E0] border-t-[#C5A059] animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function PublicOnly({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user) return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors />
          <Routes>
            <Route path="/login" element={<PublicOnly><Login /></PublicOnly>} />
            <Route path="/register" element={<PublicOnly><Register /></PublicOnly>} />
            <Route path="/forgot-password" element={<PublicOnly><ForgotPassword /></PublicOnly>} />
            <Route path="/reset-password" element={<PublicOnly><ResetPassword /></PublicOnly>} />
            {/* Portale cliente — pubblico (no auth, no protect): vi si accede tramite share-token JWT */}
            <Route path="/r/:token" element={<PortalCliente />} />
            <Route path="/" element={<Protected><Dashboard /></Protected>} />
            <Route path="/client/:id" element={<Protected><ClientProfile /></Protected>} />
            <Route path="/client/:id/analysis" element={<Protected><NewAnalysis /></Protected>} />
            <Route path="/analysis/:id" element={<Protected><AnalysisDetail /></Protected>} />
            <Route path="/piani" element={<Protected><Plans /></Protected>} />
            <Route path="/admin" element={<Protected><Admin /></Protected>} />
            <Route path="/aiuto" element={<Protected><Help /></Protected>} />
            <Route path="/academy" element={<Protected><Academy /></Protected>} />
            <Route path="/updates" element={<Protected><Updates /></Protected>} />
            <Route path="/profilo" element={<Protected><Profile /></Protected>} />
            <Route path="/beta-color" element={<Protected><BetaColor /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
